import { createSlice } from "@reduxjs/toolkit";
// import welComePage from "../CommonFunctions/jsonData/welcomePage.json";
const initialState = {
  slides: 1,
  backgroundImage: "",
  backgroundColor: "",
  fontSize: 14,
  fontColor: "#000000",
  fontFamily: "Arial",
  downloadCounter: 0,
  downloadableImages: [],
  executeDownload: 0,
  executePreview: 0,
  openColorPicker: false,
  openBgColorPicker: false,
  spaceBoxOpen: false,
  pencilBoxOpen: false,
  strokeBoxOpen: false,
  openOpacityBox: false,
  shapesDrawerOpen: false,
  templatesDrawerOpen: false,
  imagesDrawerOpen: false,
  clipArtDrawerOpen: false,
  emojiDrawerOpen: false,
  shadowBoxOpen: false,
  gradientBoxOpen: false,
  customGradientBoxOpen: false,
  lineColorBoxOpen: false,
  shadowColorBoxOpen: false,
  custom2GradientBoxOpen: false,
  templates: false,
  canvases: [],
  currentSlide: 0,
  currentCanvasData: "",
  isDrawingMode: false,
  canvasSize: {
    key: "square",
    width: 1080,
    height: 1080,
    scale: 0.7,
    marginTop: -140,
  },
};

const popupVisibility = (state) => {
  state.openColorPicker = false;
  state.spaceBoxOpen = false;
  state.shapesDrawerOpen = false;
  state.openOpacityBox = false;
  state.strokeBoxOpen = false;
  state.shadowBoxOpen = false;
  state.gradientBoxOpen = false;
  state.custom2GradientBoxOpen = false;
  state.customGradientBoxOpen = false;
  state.lineColorBoxOpen = false;
  state.shadowColorBoxOpen = false;
  state.openBgColorPicker = false;
  state.pencilBoxOpen = false;
};
export const creatorSlice = createSlice({
  name: "creator",
  initialState,
  reducers: {
    setSlides: (state, action) => {
      state.slides = Number(action.payload);
    },
    setBackgroundImage: (state, action) => {
      state.backgroundImage = action.payload;
    },
    setBackgroundColor: (state, action) => {
      state.backgroundImage = "";
      state.backgroundColor = action.payload;
    },
    setDownloadCounter: (state, action) => {
      state.downloadCounter++;
      state.downloadableImages = [];
    },
    setDownload: (state, action) => {
      state.downloadableImages[action.payload.index] = action.payload.image;
      if (state.downloadableImages.length === state.slides) {
        state.executeDownload++;
      }
    },
    setIsDrawingMode: (state, action) => {
      state.isDrawingMode = action.payload;
    },
    createSlide: (state, action) => {
      state.slides += 1;
      state.canvases.push({
        objects: [],
        background: `${
          state.backgroundImage
            ? state.backgroundImage
            : state.backgroundColor
            ? state.backgroundColor
            : "#ffffff"
        }`,
      });
    },
    setCurrentSlide: (state, action) => {
      state.currentSlide = action.payload;
    },
    setCurrentCanvas: (state, action) => {
      state.currentCanvasData = { ...state.canvases[action.payload] };
    },
    setUpdatedCanvas: (state, action) => {
      state.canvases[action.payload.canvasIndex] = { ...action.payload.data };
      state.currentCanvasData = { ...action.payload.data };
    },
    removeSlide: (state, action) => {
      state.canvases.splice(action.payload, 1);
    },
    downloadPages: (state, action) => {
      state.executeDownload++;
    },
    previewPages: (state, action) => {
      state.executePreview++;
    },
    copySlide: (state, action) => {
      state.canvases.push(state.currentCanvasData);
    },
    copySelectedToAll: (state, action) => {
      state.canvases.map((canvas, i) => {
        state.canvases[i].objects.push(action.payload);
        return null;
      });
    },
    changeCanvasSize: (state, action) => {
      state.canvasSize = action.payload;
    },
    setOpenBgColorPicker: (state, action) => {
      popupVisibility(state);
      state.openBgColorPicker = action.payload;
    },
    setOpenColorPicker: (state, action) => {
      popupVisibility(state);
      state.openColorPicker = action.payload;
    },
    setOpacityBoxOpen: (state, action) => {
      popupVisibility(state);
      state.openOpacityBox = action.payload;
    },
    setPencilBoxOpen: (state, action) => {
      popupVisibility(state);
      state.pencilBoxOpen = action.payload;
    },
    setSpaceBoxOpen: (state, action) => {
      popupVisibility(state);
      state.spaceBoxOpen = action.payload;
    },
    setShadowBoxOpen: (state, action) => {
      popupVisibility(state);
      state.shadowBoxOpen = action.payload;
    },
    setStrokeBoxOpen: (state, action) => {
      popupVisibility(state);
      state.strokeBoxOpen = action.payload;
    },
    setGradientBoxOpen: (state, action) => {
      popupVisibility(state);
      state.gradientBoxOpen = action.payload;
    },
    setCustomGradientBoxOpen: (state, action) => {
      state.customGradientBoxOpen = action.payload;
    },
    setLineColorBoxOpen: (state, action) => {
      state.shadowColorBoxOpen = false;
      state.lineColorBoxOpen = action.payload;
    },
    setShadowColorBoxOpen: (state, action) => {
      state.lineColorBoxOpen = false;
      state.shadowColorBoxOpen = action.payload;
    },
    setCustom2GradientBoxOpen: (state, action) => {
      state.custom2GradientBoxOpen = action.payload;
    },
    closeAllOpenMenus: (state, action) => {
      popupVisibility(state);
    },
    setShapesDrawer: (state, action) => {
      state.shapesDrawerOpen = action.payload;
    },
    setTemplatesDrawer: (state, action) => {
      state.templatesDrawerOpen = action.payload;
    },
    setImagesDrawer: (state, action) => {
      state.imagesDrawerOpen = action.payload;
    },
    setClipArtDrawer: (state, action) => {
      state.clipArtDrawerOpen = action.payload;
    },
    setEmojiDrawer: (state, action) => {
      state.emojiDrawerOpen = action.payload;
    },
    setTemplates: (state, action) => {
      state.templates = action.payload;
    },
    applyTemplate: (state, action) => {
      state.currentCanvasData = action.payload[0];
      state.canvases = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSlides,
  setBackgroundImage,
  setBackgroundColor,
  setDownloadCounter,
  setDownload,
  storeCanvas,
  setCurrentSlide,
  setCurrentCanvas,
  setUpdatedCanvas,
  createSlide,
  removeSlide,
  downloadPages,
  copySlide,
  copySelectedToAll,
  changeCanvasSize,
  setOpenBgColorPicker,
  setOpenColorPicker,
  setOpacityBoxOpen,
  setStrokeBoxOpen,
  setShadowBoxOpen,
  setPencilBoxOpen,
  setSpaceBoxOpen,
  closeAllOpenMenus,
  setShapesDrawer,
  setGradientBoxOpen,
  setCustomGradientBoxOpen,
  setLineColorBoxOpen,
  setShadowColorBoxOpen,
  setCustom2GradientBoxOpen,
  setTemplatesDrawer,
  setTemplates,
  applyTemplate,
  previewPages,
  setImagesDrawer,
  setClipArtDrawer,
  setIsDrawingMode,
  setEmojiDrawer,
} = creatorSlice.actions;

export default creatorSlice.reducer;
